import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";

export default function ModalClienteAutorizado({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais
    generalCustomerId,

    authorized,
    setAuthorized,

    expanded,
    loadingInputs,
    listUf,
  } = useContext(ClienteContext);
  const { handleChangeCep } = useClienteController();
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [cep, setCep] = useState("");
  const [address, setAddress] = useState("");
  const [county, setCounty] = useState("");
  const [uf, setUf] = useState(null);
  const [district, setDistrict] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [telephone2, setTelephone2] = useState("");
  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    const { data } = rowEdit;

    setName(data.nomeautorizado || "");
    setSurname(data.apelido || "");
    setCep(MaskService.toMask("cep", data.cep || ""));
    setAddress(data.endereco || "");
    setCounty(data.cidade || "");
    setDistrict(data.bairro || "");
    setTelephone1(
      MaskService.toMask(
        "cel-phone",
        `${data.ddd1 || ""}${data.telefone1 || ""}`
      )
    );
    setTelephone2(
      MaskService.toMask(
        "cel-phone",
        `${data.ddd2 || ""}${data.telefone2 || ""}`
      )
    );
  }, [rowEdit]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    setUf(
      listUf.find(
        (opt) =>
          rowEdit.data.id_estado &&
          opt.id.toString() === rowEdit.data.id_estado.toString()
      ) || null
    );
  }, [rowEdit, listUf]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const errorsValidation = { error: false, inputs: {} };

    if (!name) {
      errorsValidation.error = true;
      errorsValidation.inputs.name = "Campo obrigatório";
    }

    if (cep && !MaskService.isValid("cep", cep)) {
      errorsValidation.error = true;
      errorsValidation.inputs.cep = "CEP inválido";
    }

    if (telephone1 && !MaskService.isValid("cel-phone", telephone1)) {
      errorsValidation.error = true;
      errorsValidation.inputs.telephone1 = "Telefone inválido";
    }

    if (telephone2 && !MaskService.isValid("cel-phone", telephone2)) {
      errorsValidation.error = true;
      errorsValidation.inputs.telephone2 = "Telefone inválido";
    }

    setErrorsModal(errorsValidation.inputs);
    if (errorsValidation.error) return;

    const body = {
      nomeautorizado: name,
      apelido: surname,
      cep: cep.replace(/[^0-9]+/g, ""),
      endereco: address,
      cidade: county,
      id_estado: uf ? parseInt(uf.id) : null,
      bairro: district,
      telefone1: telephone1.replace(/[^0-9]+/g, "").substring(2),
      ddd1: telephone1.replace(/[^0-9]+/g, "").substring(0, 2),
      telefone2: telephone2.replace(/[^0-9]+/g, "").substring(2),
      ddd2: telephone2.replace(/[^0-9]+/g, "").substring(0, 2),
    };

    if (generalCustomerId) body.idclientes = generalCustomerId;

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id;

      if (rowEdit.index !== -1) {
        const copy = [...authorized];
        copy[rowEdit.index] = body;
        setAuthorized(copy);
      }
    } else {
      setAuthorized((current) => [...current, body]);
      notify("Cliente autorizado adicionado com sucesso!", true, "success");
      expanded.authorized = true;
    }

    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Autorizado
          {rowEdit && rowEdit.data.id ? `: (${rowEdit.data.id})` : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.name ? true : false}
                helperText={errorsModal.name || ""}
                label="Nome*"
                maxLength={50}
                value={name}
                setValue={setName}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Apelido"
                maxLength={50}
                value={surname}
                setValue={setSurname}
              />
            </Grid>

            <Grid item lg={4} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.cep ? true : false}
                helperText={errorsModal.cep || ""}
                label="CEP"
                maxLength={50}
                value={MaskService.toMask("cep", cep)}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep,
                    setAddress: (value) =>
                      setAddress((value || "").substring(0, 50)),
                    setComplement: () => {},
                    setCounty: (value) => {
                      setCounty((value?.municipio || "").substring(0, 50));
                    },
                    setUf,
                    setDistrict: (value) =>
                      setDistrict((value || "").substring(0, 50)),
                  })
                }
                mask="cep"
                InputProps={{
                  endAdornment: <SearchIcon onClick={() => {}} />,
                }}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Endereço"
                maxLength={50}
                value={address}
                setValue={setAddress}
              />
            </Grid>

            <Grid item lg={2} md={3} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs.listUf || false}
                label="Estado"
                value={uf}
                setValue={setUf}
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Município"
                maxLength={50}
                value={county}
                setValue={setCounty}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Bairro"
                maxLength={50}
                value={district}
                setValue={setDistrict}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.telephone1 ? true : false}
                helperText={errorsModal.telephone1 || ""}
                label="Telefone 1"
                maxLength={50}
                value={telephone1}
                setValue={setTelephone1}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.telephone2 ? true : false}
                helperText={errorsModal.telephone2 || ""}
                label="Telefone 2"
                maxLength={50}
                value={telephone2}
                setValue={setTelephone2}
                mask="cel-phone"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
